import React from 'react';
import Toast from '@atoms/Toast';
import Button from '@atoms/Button.new';

const ResetPopup = ({ interactionName, interactionType, setShowResetPopup, handleResetResults, isPreview = false, onCancel }) => {
  const getLeftPosition = () => {
    if (isPreview) {
      return 'left-[70px]';
    } else if (interactionType === 'map') {
      return 'left-[190px]';
    } else {
      return 'left-[150px]';
    }
  };

  return (
    <div
      className={`absolute bottom-22 z-20 shadow-md ${getLeftPosition()} w-[300px]`}
    >
      <Toast
        variant='notification'
        width='w-[250px] scale-150 origin-bottom'
        showIcon={false}
        header={`Reset ${interactionName}`}
        body='Pressing "Reset" will clear votes and responses for this interaction.'
        children={
          <div className='flex gap-2 justify-end' >
            <Button
              size='md'
              variant='secondary'
              onClick={() => {
                if (onCancel) {
                  onCancel();
                } else {
                  setShowResetPopup(false);
                }
              }}
            >
              Cancel
            </Button>
            <Button
              size='md'
              variant='primary'
              onClick={handleResetResults}
            >
              Reset
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default ResetPopup;
